import { FieldType, PubOtherField } from '../../../components/GenericSection/constants';
import { LOCATION, CITY, DATE_PUBLISHED } from '../../constants';

/** field list for publication raw data info section */
export var PUB_RAW_DATA_INFO_SECTION_FIELD_LIST = [{
  field: PubOtherField.LOCATION,
  labelText: LOCATION,
  recommended: true,
  type: FieldType.TEXT
}, {
  field: PubOtherField.CITY,
  labelText: CITY,
  recommended: true,
  type: FieldType.TEXT
}, {
  field: PubOtherField.PUBLISHED_DATE,
  type: FieldType.PUBDATE,
  labelText: DATE_PUBLISHED,
  formikFieldNames: ['day', 'month', 'year']
}];